module.exports = __webpack_public_path__ + "img/empty-user-avatar.1d8a766b.svg";